<script>
    export let SERVER;

    const fetchJobs = async () => {
		const response = await fetch(SERVER + '/api/jobs');
        return await response.json();
	};
</script>

<section id="jobs" class="container-fluid">
    <div id="jobs-header" class="d-flex align-items-center justify-content-center mt-5 mb-5 p-4">
        <div class="text-dark">
            <h2 class="text-center">JOB LISTINGS</h2>
            <p>Anyone who's been looking for a job or searching for a new team member to join their company</p>
        </div>
    </div>

    <div id="jobs-body" class="d-flex align-items-around align-content-center m-5">
            {#await fetchJobs()}
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            {:then responseJson}
                <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    {#each responseJson.data as job, index}
                        <button class="{index == 0 ? 'nav-link active' : 'nav-link'}" id="v-pills-{job.uuid}-tab" data-bs-toggle="pill" data-bs-target="#v-pills-{job.uuid}" type="button" role="tab" aria-controls="v-pills-{job.uuid}" aria-selected="true">{job.title}</button>
                    {/each}
                </div>
                <div class="tab-content" id="v-pills-tabContent">
                    {#each responseJson.data as job, index}
                        <div class="{index == 0 ? 'tab-pane fade show active' : 'tab-pane fade show'}" id="v-pills-{job.uuid}" role="tabpanel" aria-labelledby="v-pills-{job.uuid}-tab" tabindex="0">
                            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                <button class="btn btn-primary btn-lg" type="button">Apply</button>
                            </div>

                            {#if job.summary}
                                <h4>Summary</h4>
                                <div>
                                    {job.summary}
                                </div>
                            {/if}

                            {#if job.info.description}
                                <h4>Description</h4>
                                <div>
                                    {@html job.info.description}
                                </div>
                            {/if}

                            {#if job.info.key_qualifications}
                                <h4>Key qualifications</h4>
                                <div>
                                    {@html job.info.key_qualifications}
                                </div>
                            {/if}

                            {#if job.info.education_experience}
                                <h4>Education experience</h4>
                                <div>
                                    {@html job.info.education_experience}
                                </div>
                            {/if}

                            {#if job.info.additional_requirements}
                                <h4>Additional requirements</h4>
                                <div>
                                    {@html job.info.additional_requirements}
                                </div>
                            {/if}
                        </div>
                    {/each}
                </div>
            {:catch error}
                <p>An error occurred!</p>
            {/await}
    </div>

</section>

<style>
    #jobs {
        background-color: #eff0f2;
    }

    #jobs-body {

    }

    .nav-link {
        width: 30vw;
    }

</style>
